import type { Translate } from 'next-translate';
import React from 'react';
import { TrustpilotWidget } from '@/components/elements/TrustpilotWidget';
import type { LandingMain } from '@/types';
import { GradientButton } from '../GradientButton';
import { MainMedia } from '../MainMedia';
import styles from './MainHero.module.scss';

interface Props {
	data: LandingMain['hero'];
	t: Translate;
	locale: string;
	toolsHref: string;
	onCtaClick: () => void;
}

export const MainHero: React.FC<Props> = ({
	data,
	t,
	locale,
	toolsHref,
	onCtaClick,
}) => (
	<section className={styles['hero']}>
		<MainMedia
			media={data.media}
			alt={t(data.media.alt)}
			sizes='100vw'
			priority
			className={styles['hero__background']}
		/>

		<div className={styles['hero__content']}>
			<h1 className={styles['hero__title']}>{t(data.title)}</h1>
			<p className={styles['hero__subtitle']}>{t(data.subtitle)}</p>

			<GradientButton
				href={toolsHref}
				text={t(data.buttonText)}
				onClick={onCtaClick}
				className={styles['hero__button']}
			/>
		</div>

		<div className={styles['hero__rating']}>
			<TrustpilotWidget locale={locale} theme='dark' height='24px' />
		</div>
	</section>
);
